import { useState, useEffect } from 'react';
import cookies from 'js-cookie';

const DISMISSED_SHOP_V2_COOKIE = 'dismissedShopifyShop';

export function useShowShopBannerV2() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasDismissedShop = cookies.get(DISMISSED_SHOP_V2_COOKIE);
    if (hasDismissedShop) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    cookies.set(DISMISSED_SHOP_V2_COOKIE, 'true');
  };

  return { isOpen, setIsOpen, handleClose };
}
